import axios from 'axios';
import type {
  IGetKeyholderInvoicesQuery,
  IGetKeyholderInvoicesRequest,
  IGetKeyholderInvoicesResponse,
} from '@/app-package';

const getKeyholderInvoices = async (query: IGetKeyholderInvoicesQuery) => {
  const config: IGetKeyholderInvoicesRequest = {
    url: `/supra/keyholder_invoices/?supraOCN=${query.supraOCN}&billingCustomerNumber=${query.billingCustomerNumber}`,
    method: 'get',
  };

  const { data } = await axios.request<IGetKeyholderInvoicesResponse>(config);
  return data;
};

export default getKeyholderInvoices;
